import { axiosPost, axiosGet } from "../react_axios/Axios"
import {
  platform, headers,
  primaryChapterUrl, PRIMARY_CHAPTER_ADD_ACTION_TYPE,getPreviewDetailsUrl,PREVIEW_DETAILS_ACTION_TYPE
} from "../utils/constants"


export const primaryChapterAdd_action = (ExhibitionID, exhRegistrationID, ExhibitionStallSizeID, StallArea, StallTypeID, OpenSides, chapterList,primaryChapterRadioId) => async (dispatch) => {
  try {
    console.log("exhRegistrationID", exhRegistrationID)

    const mapdata = {
      ExhibitionID: ExhibitionID,
      ExhRegistrationID: exhRegistrationID,
      ExhibitionStallSizeID: ExhibitionStallSizeID,
      StallArea: 0,
      StallTypeID: StallTypeID,
      OpenSides: OpenSides,
      chapterList: chapterList,
      PrimaryChapter : primaryChapterRadioId
    }

    const res = await axiosPost(primaryChapterUrl, mapdata, headers);
    dispatch({
      type: PRIMARY_CHAPTER_ADD_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getPreviewDetails_action = (ExhRegistrationID, ExhibitionID) => async (dispatch) => {
  try {
    const mapdata = {
      ExhRegistrationID : ExhRegistrationID,
      ExhibitionID : ExhibitionID,
    }

    const res = await axiosGet(getPreviewDetailsUrl, mapdata, headers);
    dispatch({
      type: PREVIEW_DETAILS_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
